/* Countdown for campaign landing pages. Event times are read as India
   Standard Time so every visitor sees the same target. */
const IST_OFFSET = '+05:30';

const parseEventTime = text => {
  const match = /(\d{1,2})(?::(\d{2}))?\s*(am|pm)?/i.exec(text || '');
  if (!match) return { hours: 0, minutes: 0 };
  let hours = Number(match[1]) % 12;
  const minutes = Number(match[2] || 0);
  if ((match[3] || '').toLowerCase() === 'pm') hours += 12;
  if (!match[3] && Number(match[1]) > 12) hours = Number(match[1]);
  return { hours, minutes };
};

const pad = value => String(value).padStart(2, '0');

const startCountdown = element => {
  const { hours, minutes } = parseEventTime(element.dataset.eventTime);
  const target = new Date(`${element.dataset.eventDate}T${pad(hours)}:${pad(minutes)}:00${IST_OFFSET}`);
  if (Number.isNaN(target.getTime())) return;
  const fields = {
    days: element.querySelector('[data-count="days"]'),
    hours: element.querySelector('[data-count="hours"]'),
    minutes: element.querySelector('[data-count="minutes"]'),
  };
  const render = () => {
    const remaining = target.getTime() - Date.now();
    if (remaining <= 0) {
      element.setAttribute('hidden', '');
      return false;
    }
    const totalMinutes = Math.floor(remaining / 60000);
    fields.days.textContent = Math.floor(totalMinutes / 1440);
    fields.hours.textContent = Math.floor((totalMinutes % 1440) / 60);
    fields.minutes.textContent = totalMinutes % 60;
    element.removeAttribute('hidden');
    return true;
  };
  if (render()) {
    const timer = setInterval(() => { if (!render()) clearInterval(timer); }, 30000);
  }
};

document.querySelectorAll('[data-mp-countdown]').forEach(startCountdown);
